import * as d3 from 'd3'
export default {
  methods: {

    reflash_Chart() {

      this.current.reflash = 'Transiton'

      this.init_ChartData()
      this.chart_Controller()
      this.legend_Controller()

      d3.select(`#SUMMARY`).remove()
    },


    reflash_Grid() {
      for(let i=0; i<6; i++) {
        let value = (this.primary.max * (i*.2)).toFixed(1)
        if(this.primary.unit.toLowerCase() == 'k') value = (value/1000)
        this.gmx_textTween(`#PRIMARY_${i}`, value, 300, this.primary.unit)

        value = (this.secondary.max * (i*.2)).toFixed(0)
        if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000)
        this.gmx_textTween(`#SECONDARY_${i}`, value, 300, this.secondary.unit)
      }
    },

    // Called by toggle_action()
    reflash_Toggle() {
      this.current.reflash = 'Toggle'

      // Re-create removed canvases
      this.canvasBase = this.canvasForm
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.canvasChart = this.canvasForm
      .append('g')
      .attr('id', `CHART_CANVAS`)
      .attr('transform', `translate(${this.chart.padding.left}, ${this.chart.padding.top})`)

      // console.log(this.chartData)

      this.init_ChartData()
      this.draw_ChartAxis(this.canvasBase)
      this.draw_Grid(this.canvasBase)

      this.draw_chartTimeline(this.canvasBase)
      this.chart_Controller()
      this.draw_Milestone()
      this.legend_Controller()

    },

  }
}